import { getEnvVar } from '@rea-argonaut/env';

export const getEnv = {
  INTERNAL_EXPERIENCE_API_URL: () => getEnvVar<string>('internalExperienceApiUrl') || '',
  PUBLIC_EXPERIENCE_API_URL: () => getEnvVar<string>('publicExperienceApiUrl') || '',
  LOCKE_CLIENT_ID: () => getEnvVar<string>('lockeClientId') || '',
  LOCKE_BASE_URL: () => getEnvVar<string>('lockeBaseUrl') || '',
  CANONICAL_DOMAIN: () => getEnvVar<string>('canonicalDomain') || '',
  GOOGLE_API_KEY: () => getEnvVar<string>('googleApiKey') || '',
};
